import { render, staticRenderFns } from "./RatingRegularPage.vue?vue&type=template&id=038f1cca&scoped=true"
import script from "./RatingRegularPage.vue?vue&type=script&lang=js"
export * from "./RatingRegularPage.vue?vue&type=script&lang=js"
import style0 from "./RatingRegularPage.vue?vue&type=style&index=0&id=038f1cca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f1cca",
  null
  
)

export default component.exports